import axios from '../../../utils/request';

function CUSTOMER_ORDERS(params) {
    return  axios.get("/customer/MServiceOrder/customerOrder",{
        params: {
            ...params
        }
    } )
}

function GET_LIST(params) {
    return  axios.get("/customer/MServiceOrder/index",{
        params: {
            ...params
        }
    } )
}
export default {
    CUSTOMER_ORDERS,GET_LIST
};
